import { Injectable } from "@angular/core";
import { ConnectionServices } from "./connection/connection.service";
import { IUserInfo, IdentityService, RolesEnum } from "./identity.service";
import { MultiRegionService } from "../multiregion/multiregion.service";
import { PushNotificationService } from "../utilities/push-notification.service";
import { Observable, catchError, concatMap, endWith, firstValueFrom, ignoreElements, iif, map, mergeMap, of, switchMap, take, throwError } from "rxjs";
import { ILogInCommandParameters, LogInCommand } from "./command/logIn.command";
import { RequestHeader } from "./connection/requestHeader";
import { GenericPlace } from "../models/generic-place.model";
import { GetAdminInfoCommand, IGetAdminInfoCommandParameters } from "./command/getAdminInfo.command";
import { UpdateFirebaseTokenCommand } from "./command/updateFirebaseToken.command";
import { GetCarrierInfoByUserCommand, IGetCarrierInfoCommandParameters } from "../carrier/command/getCarrierInfoByUser.command";
import { UpdatePBXWaitCommand } from "../carrier/command/updatePBXWait.command";
import { MenuService } from "../menu/menu.services";
import { LocalizationService } from "../localization/localization.service";


@Injectable()
export class AuthenticationService {
  constructor(
    private _connectionService: ConnectionServices,
    // private _multiRegionService: MultiRegionService,
    private _identityService: IdentityService,
    // private _notificationsService: NotificationsService,
    // private _navigationService: NavigationService,
    // private _ngProgressService: NgProgress,
    private _pushNotificationService: PushNotificationService,
    // public _localizationService: LocalizationService,
    private _multiRegionService: MultiRegionService,
    private _menuService: MenuService,
    private _localizationService: LocalizationService
  ) {}

  // public logOut() {
  //   let rol = this._identityService.rol;
  //   return this._identityService.logOut().subscribe(
  //     (result) => {
  //       switch (rol) {
  //         case RolesEnum.ROLE_ADMIN:
  //           this._navigationService.navigate(RouterEnum.loginAdmin);
  //           break;
  //         case RolesEnum.ROLE_CONTRACTOR_OPERATOR:
  //         case RolesEnum.ROLE_CONTRACTOR_SECRETARY:
  //         case RolesEnum.ROLE_CONTRACTOR_ADMINISTRATIVE:
  //         case RolesEnum.ROLE_CONTRACTOR_MANAGER:
  //         case RolesEnum.ROLE_CONTRACTOR:
  //           this._navigationService.navigate(RouterEnum.loginContractor);
  //           break;
  //         case RolesEnum.ROLE_VEHICLEOWNER:
  //           this._navigationService.navigate(RouterEnum.loginOwner);
  //           break;
  //         default:
  //           this._navigationService.navigate(RouterEnum.loginCarrier);
  //       }
  //       return true;
  //     },
  //     (error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.authentication.logout',
  //         error
  //       );
  //       return Observable.throw(false);
  //     }
  //   );
  // }

  /// This method generate login in server, and save token and data
  public login(
    username: string,
    password: string,
    remember: boolean,
    rol: RolesEnum
  ): Observable<any> {
    // this._ngProgressService.start();
    let loginCommand = new LogInCommand();
    loginCommand.setParameters(<ILogInCommandParameters>{
      username: username,
      password: password,
    });

    let headers = new Array<RequestHeader>();
    headers.push(<RequestHeader>{
      name: 'RoleToAttempt',
      value: rol,
    });

    loginCommand.addCustomHeaders(headers);

  return this._connectionService
  .Request(loginCommand)
  .pipe(
    mergeMap((loginResponse) =>
      this._identityService
        .setLoginInfo(loginResponse)
        .pipe(
          // Avanza cuando setInitData emita por PRIMERA vez (no espera a que complete)
          mergeMap(() => this.setInitData(rol).pipe(take(1))),

          // Posteá el token UNA sola vez
          mergeMap(() => this.postFirebaseToken(this._identityService.sessionToken)),

          // ⬇️ PRELOAD del menú solo si hay token (y tragamos errores)
          concatMap(() =>
            iif(
              () => !!this._identityService.sessionToken,
              this._menuService.getCarrierMenu().pipe(
                take(1),
                catchError(() => of([]))
              ),
              of([])
            )
          ),

          concatMap(() =>
            iif(
              () => !!this._identityService.sessionToken,
              this._localizationService.getCountryLocaleSettings(
                this._identityService.countryCode
                ? this._identityService.countryCode
                : 'AR'
              ).pipe(
                take(1),
                catchError(() => of([]))
              ),
              of([])
            )
          ),

          map(() =>
            loginResponse
          ),
          // mergeMap(() => this._pushNotificationService.getToken()),
          // tap(() => this._ngProgressService.done()), // Use tap for side effects
        )
    ),
    catchError((error) => {
      // this._ngProgressService.done();
      this._identityService.logOut();

      // if (error.status === 401) {
      //     this._notificationsService.showInternalErrorMessage(
      //     'toast.authentication.login',
      //     'toast.authentication.error_code.user_invalid'
      //     );
      // } else if (error.status === 403) {
      //     switch (error.error) {
      //     case 'INVALID_ROLE': {
      //         this._notificationsService.showInternalErrorMessage(
      //         'toast.authentication.login',
      //         'toast.authentication.error_code.role_invalid'
      //         );
      //         break;
      //     }
      //     case 'INACTIVE_USER': {
      //         this._notificationsService.showInternalErrorMessage(
      //         'toast.authentication.login',
      //         'toast.authentication.error_code.user_inactive'
      //         );
      //         break;
      //     }
      //     }
      // } else {
      //     this._notificationsService.showHttpErrorMessage(
      //     'toast.authentication.login',
      //     error
      //     );
      // }

      return throwError(error); // Re-throw the error for further handling (optional)
    }));


  }

  // public signUp(
  //   email: string,
  //   password: string,
  //   cuit: string
  // ): Observable<boolean> {
  //   let signUpCommand = new SignUpCommand();
  //   signUpCommand.setParameters(<ISignUpCommandParameters>{
  //     email: email,
  //     password: password,
  //     cuit: cuit,
  //   });
  //   return this._connectionService
  //     .Request(signUpCommand)
  //     .flatMap((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.authentication.registration',
  //         'toast.authentication.message.solicitude_sent'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.authentication.registration',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }
  // public confirmAccount(token: string): Observable<boolean> {
  //   let confirmAccountCommand = new ConfirmAccountCommand();
  //   confirmAccountCommand.setParameters(<IConfirmAccountCommandParameters>{
  //     token: token,
  //   });
  //   return this._connectionService
  //     .Request(confirmAccountCommand)
  //     .flatMap((confirmAccountResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.authentication.confirm',
  //         'toast.authentication.message.confirm_success'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.authentication.confirm',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public isLogged(rol: RolesEnum): Observable<boolean> {
  //   return this._identityService.isLogged().flatMap((isLogged) => {
  //     if (isLogged) {
  //       return this.setInitData(rol).map((response) => {
  //         return isLogged;
  //       });
  //     } else {
  //       return Observable.create(function (observer) {
  //         observer.next(isLogged);
  //       });
  //     }
  //   });
  // }

  // public signUpCarrier(
  //   solicitudeId: number,
  //   data: CompanyRegistrationDto
  // ): Observable<boolean> {
  //   let signUpCommand = new SignUpCarrierCommand();
  //   signUpCommand.setIds(solicitudeId);
  //   signUpCommand.setParameters(<ISignUpCarrierCommandParameters>{
  //     tributeNumber: data.tributeNumber,
  //     companyName: data.companyName,
  //     tributeName: data.tributeName,
  //     tributeCondition: data.tributeCondition,
  //     legalRepresentative: data.legalRepresentative,
  //     comments: data.comments,
  //   });
  //   return this._connectionService
  //     .Request(signUpCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.authentication.registration',
  //         'toast.authentication.message.solicitude_sent'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status === 401) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.authentication.error_code.user_invalid'
  //         );
  //       } else if (error.status === 403) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.authentication.error_code.role_invalid'
  //         );
  //       } else if (error.error.errorCode === 'MAIL_UNIQUE') {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.authentication.error_code.mail_unique'
  //         );
  //       } else if (error.error.errorCode === 'SOLICITUDE_INVALID_STATE') {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.authentication.error_code.solicitude_invalid'
  //         );
  //       } else if (error.error.errorCode === 'CUIL_UNIQUE') {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.users.error_code.cuil_unique'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.registration',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public signUpCarrierAccount(
  //   data: CarrierAccountRegistrationRequestDto
  // ): Observable<boolean> {
  //   let signUpCommand = new SignUpCarrierAccountCommand();
  //   signUpCommand.setParameters(<ISignUpCarrierAccountCommandParameters>{
  //     email: data.email,
  //     password: data.password,
  //     languageCode: data.languageCode,
  //   });
  //   return this._connectionService
  //     .Request(signUpCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.authentication.registration',
  //         'toast.authentication.message.solicitude_sent'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status === 401) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.authentication.error_code.user_invalid'
  //         );
  //       } else if (error.status === 403) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.authentication.error_code.role_invalid'
  //         );
  //       } else if (error.status === 409) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.users.error_code.mail_unique'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.registration',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }
  // public validateCarrierRegion(
  //   solicitudeId: number,
  //   data: CarrierRegionValidationRequestDto
  // ): Observable<boolean> {
  //   let validateRegion = new ValidateCarrierRegionRegistrationCommand();
  //   validateRegion.setId(solicitudeId);
  //   validateRegion.setParameters(
  //     <ICarrierRegionValidationCommandParameters>data
  //   );
  //   return this._connectionService
  //     .Request(validateRegion)
  //     .map((signUpResponse) => {
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status === 500) {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.registration',
  //           error
  //         );
  //       } else if (error.status !== 400) {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.registration',
  //           error
  //         );
  //       }
  //       return Observable.throw(error.error);
  //     });
  // }

  // public signUpContractor(
  //   data: ContractorRegistrationRequestDto
  // ): Observable<boolean> {
  //   let signUpCommand = new SignUpContractorCommand();
  //   signUpCommand.setParameters(<ISignUpContractorCommandParameters>{
  //     imageLogo: data.imageLogo,
  //     companyName: data.companyName,
  //     companyFantasyName: data.companyFantasyName,
  //     tributeNumber: data.tributeNumber,
  //     tributeNumberImage: data.tributeNumberImage,
  //     email: data.email,
  //     checkingAccount: data.checkingAccount,
  //     expenseReportMode: data.expenseReportMode,
  //     phoneNumber: data.phoneNumber,
  //     password: data.password,
  //     country: data.country,
  //     locationPlace: data.locationPlace,
  //     billingPlace: data.billingPlace,
  //   });
  //   return this._connectionService
  //     .Request(signUpCommand)
  //     .map((signUpResponse) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.authentication.registration',
  //         'toast.authentication.message.solicitude_sent'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.status === 401) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.authentication.error_code.user_invalid'
  //         );
  //       } else if (error.status === 403) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.authentication.error_code.role_invalid'
  //         );
  //       } else if (error.status === 409) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.registration',
  //           'toast.users.error_code.email_name_unique'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.registration',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public recoverPassword(email: string): Observable<boolean> {
  //   const recoverPasswordCommand = new RecoverPasswordCommand();
  //   recoverPasswordCommand.setParameters(<IRecoverPasswordCommandParameters>{
  //     email: email,
  //   });

  //   return this._connectionService
  //     .Request(recoverPasswordCommand)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.authentication.recovery',
  //         'toast.authentication.message.password_recovery'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === ErrorsEnum.USER_NOT_FOUND) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.password_update',
  //           'toast.authentication.error_code.verify_email'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.admin.admin_info',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public changePassword(request: ChangePasswordRequestDTO) {
  //   const changePasswordCommand = new ChangePasswordCommand();
  //   changePasswordCommand.setParameters(<IChangePasswordCommandParameters>{
  //     userId: request.userId,
  //     password: request.password,
  //     tokenConfirmation: request.tokenConfirmation,
  //   });

  //   return this._connectionService
  //     .Request(changePasswordCommand)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.authentication.password_recovery',
  //         'toast.authentication.message.password_updated_successfully'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === ErrorsEnum.USER_NOT_FOUND) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.password_update',
  //           'toast.authentication.error_code.password_recovery_user_not_found'
  //         );
  //       } else if (
  //         error.error.errorCode === ErrorsEnum.INVALID_RESET_PASSWORD_TOKEN
  //       ) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.password_update',
  //           'toast.authentication.error_code.invalid_recovery_token'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.admin.info_admin',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public changePasswordLogged(request: ChangePasswordLoggedRequestDTO) {
  //   const changePasswordCommand = new ChangePasswordLoggedCommand();
  //   changePasswordCommand.setParameters(<
  //     IChangePasswordLoggedCommandParameters
  //   >{
  //     userId: this._identityService.subUserId,
  //     password: request.password,
  //     currentPassword: request.currentPassword,
  //   });

  //   return this._connectionService
  //     .Request(changePasswordCommand)
  //     .map((response) => {
  //       this._notificationsService.showSuccessMessage(
  //         'toast.authentication.password_update',
  //         'toast.authentication.message.password_updated_successfully'
  //       );
  //       return new Observable<true>();
  //     })
  //     .catch((error) => {
  //       if (error.error.errorCode === ErrorsEnum.USER_NOT_FOUND) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.password_update',
  //           'toast.authentication.error_code.password_recovery_user_not_found'
  //         );
  //       } else if (
  //         error.error.errorCode === ErrorsEnum.INVALID_CURRENT_PASSWORD
  //       ) {
  //         this._notificationsService.showInternalErrorMessage(
  //           'toast.authentication.password_update',
  //           'toast.authentication.error_code.password_invalid'
  //         );
  //       } else {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.admin.info_admin',
  //           error
  //         );
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  private setInitData(rol: RolesEnum): any {
    switch (rol) {
      // case RolesEnum.ROLE_ADMIN:
        // return this.getAdminInfo(rol).flatMap((userInfo) => {
        //   return this._multiRegionService
        //     .getPages(this._multiRegionService.getCountry())
        //     .map((pages) => {
        //       return userInfo;
        //     });
        // });
        // return this.getAdminInfo(rol).pipe(
        //     map((userInfo) => {
        //       this._multiRegionService.getPages(this._multiRegionService.getCountry()); // Call for side effects
        //       return userInfo;
        //     })
        // );
      case RolesEnum.ROLE_CARRIER_ADMINISTRATIVE:
      case RolesEnum.ROLE_CARRIER_MANAGER:
      case RolesEnum.ROLE_CARRIER_OPERATOR:
      case RolesEnum.ROLE_CARRIER:
        return this.getCarrierInfoByUser(rol).pipe(
          mergeMap((userInfo) => {
            return this._multiRegionService.getPages(this._multiRegionService.getCountry()).pipe(
              map(x=>{
                return userInfo
              })
            ); // Call for side effects
          })
        );
    //   case RolesEnum.ROLE_CONTRACTOR_OPERATOR:
    //   case RolesEnum.ROLE_CONTRACTOR_SECRETARY:
    //   case RolesEnum.ROLE_CONTRACTOR_ADMINISTRATIVE:
    //   case RolesEnum.ROLE_CONTRACTOR_MANAGER:
    //   case RolesEnum.ROLE_CONTRACTOR:
    //     return this.getContractorInfoByUser().flatMap((userInfo) => {
    //       return this._multiRegionService
    //         .getPages(this._multiRegionService.getCountry())
    //         .map((pages) => {
    //           return userInfo;
    //         });
    //     });
    //   case RolesEnum.ROLE_VEHICLEOWNER:
    //     return this.getOwnerInfoByUser(rol).flatMap((userInfo) => {
    //       return this._multiRegionService
    //         .getPages(this._multiRegionService.getCountry())
    //         .map((pages) => {
    //           return userInfo;
    //         });
    //     });
    //   default:
    //     this._notificationsService.showInternalErrorMessage(
    //       'toast.authentication.login',
    //       'toast.authentication.error_code.role_invalid'
    //     );
    }
  }

  // getOwnerInfoByUser(rol: RolesEnum) {
  //   const ownerUserId = this._identityService.userId;
  //   let getOwnerInfoCommand = new GetOwnerInfoByUserCommand();
  //   getOwnerInfoCommand.setParameters(<IGetOwnerInfoCommandParameters>{
  //     ownerUserId: ownerUserId,
  //   });
  //   return this._connectionService
  //     .Request(getOwnerInfoCommand)
  //     .flatMap((userInfo) => {
  //       return this._pushNotificationService
  //         .getToken()
  //         .flatMap((firebaseToken) => {
  //           return this._identityService
  //             .setUserInfo(
  //               this.setUserInfo(
  //                 userInfo.carrier.id,
  //                 userInfo.carrier.carrierImageLogo,
  //                 userInfo.country,
  //                 userInfo.carrier.countryCode,
  //                 userInfo.titularDescription,
  //                 userInfo.carrier.companyName,
  //                 userInfo.contactEmail,
  //                 rol,
  //                 userInfo.carrier.magiisNumber,
  //                 userInfo.carrier.locationPlace,
  //                 firebaseToken,
  //                 userInfo.id,
  //                 ownerUserId,
  //                 null,
  //                 null,
  //                 null,
  //                 null,
  //                 null,
  //                 null,
  //                 null,
  //                 null,
  //                 null,
  //                 null,
  //                 null,
  //                 userInfo.isOwnerPlatformUser,
  //               )
  //             )
  //             .map((x) => {
  //               return userInfo;
  //             });
  //         });
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.carrier.info',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  private getCarrierInfoByUser(rol: RolesEnum) {
    const carrierUserId = this._identityService.userId;
    let getCarrierInfoCommand = new GetCarrierInfoByUserCommand();
    getCarrierInfoCommand.setParameters(<IGetCarrierInfoCommandParameters>{
      carrierUserId,
    });
    return this._connectionService
    .Request(getCarrierInfoCommand)
    .pipe(
        mergeMap((userInfo: any) =>
        this._identityService.setUserInfo(
            this.setUserInfo(
              userInfo.id,
                userInfo.carrierImageLogo,
                userInfo.country,
                userInfo.countryCode,
                userInfo.firstName + ' ' + userInfo.lastName,
                userInfo.companyName,
                userInfo.carrierUserEmail,
                rol,
                userInfo.code,
                userInfo.locationPlace,
                null, //Implementar luego con las notificaciones
                undefined,
                carrierUserId,
                null,
                null,
                userInfo.mercadopagoAppId,
                userInfo.mercadopagoAppCode,
                userInfo.mercadoPagoAvailable,
                userInfo.subUserName,
                userInfo.affiliateProfileId,
                userInfo.disableFunctions,
                userInfo.affiliateProfileActive,
                userInfo.affiliateProfileCreditCardWarrantyExpired,
                null,
                null,
                userInfo.flightApiAvailable,
                userInfo.flightApiName,
                userInfo.gnetApiAvailable,
                userInfo.maxRouteWaypoints,
                userInfo.paymentVendorAvailableInCarrierCountry,
            )
        )),
        map((x) => x), // Assuming you want to return the original userInfo
        catchError((error) => {
            return throwError(() => false);
        })
    );
    // return this._connectionService
    //   .Request(getCarrierInfoCommand)
    //   .flatMap((userInfo) => {
    //     console.log('userInfo: ', userInfo);
    //     return this._pushNotificationService
    //       .getToken()
    //       .flatMap((firebaseToken) => {
    //         return this._identityService
    //           .setUserInfo(
    //             this.setUserInfo(
    //               userInfo.id,
    //               userInfo.carrierImageLogo,
    //               userInfo.country,
    //               userInfo.countryCode,
    //               userInfo.firstName + ' ' + userInfo.lastName,
    //               userInfo.companyName,
    //               userInfo.carrierUserEmail,
    //               rol,
    //               userInfo.code,
    //               userInfo.locationPlace,
    //               firebaseToken,
    //               undefined,
    //               carrierUserId,
    //               null,
    //               null,
    //               userInfo.mercadopagoAppId,
    //               userInfo.mercadopagoAppCode,
    //               userInfo.mercadoPagoAvailable,
    //               userInfo.subUserName,
    //               userInfo.affiliateProfileId,
    //               userInfo.disableFunctions,
    //               userInfo.affiliateProfileActive,
    //               userInfo.affiliateProfileCreditCardWarrantyExpired,
    //               userInfo.paymentVendorAvailableInCarrierCountry,
    //               null,
    //               userInfo.flightApiAvailable,
    //               userInfo.flightApiName,
    //               userInfo.gnetApiAvailable
    //             )
    //           )
    //           .map((x) => {
    //             return userInfo;
    //           });
    //       });
    //   })
    //   .catch((error) => {
    //     this._notificationsService.showHttpErrorMessage(
    //       'toast.carrier.info',
    //       error
    //     );
    //     return Observable.throw(false);
    //   });
  }

  // private getCarrierInfo(rol: RolesEnum) {
  //   let getCarrierInfoCommand = new GetCarrierInfoCommand();
  //   getCarrierInfoCommand.setParameters(<IGetCarrierInfoCommandParameters>{
  //     carrierUserId: this._identityService.userId,
  //   });
  //   return this._connectionService
  //     .Request(getCarrierInfoCommand)
  //     .flatMap((userInfo) => {
  //       return this._pushNotificationService
  //         .getToken()
  //         .flatMap((firebaseToken) => {
  //           return this._identityService
  //             .setUserInfo(
  //               this.setUserInfo(
  //                 userInfo.id,
  //                 userInfo.carrierImageLogo,
  //                 userInfo.country,
  //                 userInfo.countryCode,
  //                 userInfo.firstName + ' ' + userInfo.lastName,
  //                 userInfo.companyName,
  //                 userInfo.carrierUserEmail,
  //                 rol,
  //                 userInfo.code,
  //                 firebaseToken
  //               )
  //             )
  //             .map((x) => {
  //               return userInfo;
  //             });
  //         });
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.carrier.info',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  // public getContractorInfoByUser() {
  //   const contractorUserId = this._identityService.userId;
  //   let getContractorInfoCommand = new GetContractorInfoByUserCommand();
  //   getContractorInfoCommand.setParameters(<
  //     IGetContractorInfoCommandParameters
  //   >{
  //     contractorUserId: this._identityService.userId,
  //   });
  //   return this._connectionService
  //     .Request(getContractorInfoCommand)
  //     .pipe(
  //       mergeMap((userInfo: LoginContractorResponseDto) => {
  //         return this._pushNotificationService
  //           .getToken()
  //           .pipe(
  //             mergeMap((firebaseToken) => {
  //               return this._identityService
  //                 .setUserInfo(
  //                   this.setUserInfo(
  //                     userInfo.id,
  //                     userInfo.imageLogo,
  //                     userInfo.country,
  //                     userInfo.countryCode,
  //                     userInfo.companyFantasyName,
  //                     userInfo.companyName,
  //                     userInfo.email,
  //                     this._identityService.rol,
  //                     userInfo.magiisNumber,
  //                     userInfo.location,
  //                     '', //Agregar firebaseToken!
  //                     userInfo.passengerId,
  //                     userInfo.employeeUserId
  //                       ? userInfo.employeeUserId
  //                       : contractorUserId,
  //                     userInfo.employeePassengerId,
  //                     null,
  //                     1 /* TODO */
  //                   )
  //                 )
  //                 .pipe(
  //                   map((x) => {
  //                     return userInfo;
  //                   })
  //                 );
  //             })
  //           );
  //       }),
  //       catchError((error) => {
  //         return throwError(() => false);
  //       })
  //     );
  //   // return this._connectionService
  //   //   .Request(getContractorInfoCommand)
  //   //   .flatMap((userInfo: LoginContractorResponseDto) => {
  //   //     return this._pushNotificationService
  //   //       .getToken()
  //   //       .flatMap((firebaseToken) => {
  //   //         return this._identityService
  //   //           .setUserInfo(
  //   //             this.setUserInfo(
  //   //               userInfo.id,
  //   //               userInfo.imageLogo,
  //   //               userInfo.country,
  //   //               userInfo.countryCode,
  //   //               userInfo.companyFantasyName,
  //   //               userInfo.companyName,
  //   //               userInfo.email,
  //   //               this._identityService.rol,
  //   //               userInfo.magiisNumber,
  //   //               userInfo.location,
  //   //               firebaseToken,
  //   //               userInfo.passengerId,
  //   //               userInfo.employeeUserId
  //   //                 ? userInfo.employeeUserId
  //   //                 : contractorUserId,
  //   //               userInfo.employeePassengerId,
  //   //               null,
  //   //               1 /* TODO */
  //   //             )
  //   //           )
  //   //           .map((x) => {
  //   //             return userInfo;
  //   //           });
  //   //       });
  //   //   })
  //   //   .catch((error) => {
  //   //     // this._notificationsService.showHttpErrorMessage(
  //   //     //   'toast.contractor.company_info',
  //   //     //   error
  //   //     // );
  //   //     return throwError(() => false);
  //   //   });
  // }

  // public getAbleToUseContractorInfo(rol: RolesEnum) {
  //   let getAbleToBeContractorInfoCommand =
  //     new GetAbleToBeContractorInfoCommand();
  //   getAbleToBeContractorInfoCommand.setParameters(<
  //     IGetAbleToBeContractorInfoCommandParameters
  //   >{
  //     ableToBeContractorUserId: this._identityService.userId,
  //   });
  //   return this._connectionService
  //     .Request(getAbleToBeContractorInfoCommand)
  //     .flatMap((userInfo) => {
  //       return this._pushNotificationService
  //         .getToken()
  //         .flatMap((firebaseToken) => {
  //           return this._identityService
  //             .setUserInfo(
  //               this.setUserInfo(
  //                 userInfo.id,
  //                 userInfo.imageLogo,
  //                 userInfo.country,
  //                 userInfo.countryCode,
  //                 userInfo.firstName + ' ' + userInfo.lastName,
  //                 userInfo.companyName,
  //                 userInfo.carrierUserEmail,
  //                 rol,
  //                 userInfo.code,
  //                 firebaseToken
  //               )
  //             )
  //             .map((x) => {
  //               return userInfo;
  //             });
  //         });
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.contractor.company_info',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  private getAdminInfo(rol: RolesEnum) {
    let getAdminInfoCommand = new GetAdminInfoCommand();
    getAdminInfoCommand.setParameters(<IGetAdminInfoCommandParameters>{
      adminUserId: this._identityService.userId,
    });
    return this._connectionService
    .Request(getAdminInfoCommand)
    .pipe(
        mergeMap((userInfo: any) =>
        this._identityService.setUserInfo(
            this.setUserInfo(
                userInfo.id,
                userInfo.userImage,
                userInfo.country,
                null,
                userInfo.userFullName,
                userInfo.companyName,
                userInfo.email,
                rol,
                userInfo.code,
                null,
                null,
                null,
                null,
                null,
                userInfo.timezone
            )
        )),
        map((x) => x), // Assuming you want to return the original userInfo
        catchError((error) => {
            return throwError(() => false);
        })
    );
  }

  private setUserInfo(
    userId: number,
    userImage: string,
    country: string,
    countryCode: string,
    fullName: string,
    fantasyName: string,
    email: string,
    rol: RolesEnum,
    code: string,
    location?: GenericPlace,
    firebaseToken?: string,
    passengerId?: number,
    subUserId?: string,
    subUserPassengerId?: number,
    timezone?: number,
    mercadoPagoAppId?: number,
    mercadoPagoAppCode?: string,
    mercadoPagoAvailable?: boolean,
    subUserName?: string,
    affiliateProfileId?: number,
    disableFunctions?: string[],
    affiliateProfileActive?: boolean,
    affiliateProfileCreditCardWarrantyExpired?: string,
    isOwnerPlatformUser?: boolean,
    isContractorPlatformUser?: boolean,
    flightApiAvailable?: boolean,
    flightApiName?: string,
    gnetApiAvailable?: boolean,
    maxRouteWaypoints?: number,
    paymentVendorAvailableInCarrierCountry?: boolean,
    carrier?: any
  ): IUserInfo {
    let userInfo = <IUserInfo>{
      id: userId,
      code: code,
      userImage: userImage,
      country: country,
      countryCode: countryCode,
      fullName: fullName,
      email: email,
      firebaseToken: firebaseToken,
      rol: rol,
      locationPlace: location,
      passengerId: passengerId,
      fantasyName: fantasyName,
      subUserId: subUserId,
      subUserPassengerId: subUserPassengerId,
      timezone: timezone,
      mercadopagoAppId: mercadoPagoAppId,
      mercadopagoAppCode: mercadoPagoAppCode,
      mercadoPagoAvailable: mercadoPagoAvailable,
      subUserName: subUserName,
      isOwnerPlatformUser: isOwnerPlatformUser,
      isContractorPlatformUser: isContractorPlatformUser,
      affiliateProfileId: affiliateProfileId,
      disableFunctions: disableFunctions,
      affiliateProfileActive: affiliateProfileActive,
      affiliateProfileCreditCardWarrantyExpired:
      affiliateProfileCreditCardWarrantyExpired,
      paymentVendorAvailableInCarrierCountry:
      paymentVendorAvailableInCarrierCountry,
      flightApiAvailable: flightApiAvailable,
      flightApiName:flightApiName,
      gnetApiAvailable: gnetApiAvailable,
      maxRouteWaypoints: maxRouteWaypoints,
      carrier: carrier,
    };
    return userInfo;
  }

  postFirebaseToken(token: string) {
    let updateTokenCommand = new UpdateFirebaseTokenCommand();
    updateTokenCommand.setParameters('INVALID_TOKEN');
    return this._connectionService.Request(updateTokenCommand).pipe(
        map(() => true), // Assuming success returns true
        catchError((error) => {
          if (error.status === 409) {
            // this._notificationsService.showInternalErrorMessage(
            //   'toast.authentication.login',
            //   error.error.description
            // );
            return of(true); // Assuming conflict (409) is a success scenario here
          } else {
            // this._notificationsService.showHttpErrorMessage(
            //   'toast.authentication.login',
            //   error
            // );
            return throwError(error); // Re-throw other errors for further handling
          }
        })
      );
  }

  public async updateFirebaseToken(): Promise<void> {
    try {
      const token = await firstValueFrom(this._pushNotificationService.getToken());
      const res   = await firstValueFrom(this.postFirebaseToken(token));
      if (!res) throw new Error('INVALID_RESPONSE');

      // Espera a que cargue/ajuste la locale (y si usás ngx-translate, que haga use(lang))
      await firstValueFrom(
        this._localizationService
          .getCountryLocaleSettings(this._identityService.countryCode || 'AR')
          .pipe(
            // si tu servicio no aplica el idioma internamente,
            // acá podrías hacer: switchMap(locale => this.translate.use(locale.lang))
            map(() => void 0)
          )
      );
    } catch (e) {
      console.error('Init i10n/token error', e);
      // Importante: no re-lances si querés que la app siga arrancando
      // throw e; // <-- sólo si querés bloquear completamente el arranque
    }
  }

  // public verifyUserPermission(email: string, pass: string) {
  //   const verifyUserPermissionCommand = new VerifyUserPermissionCommand();
  //   verifyUserPermissionCommand.setParameters(<IVerifyUserPermissionParameters>{
  //     username: email,
  //     password: pass,
  //   });

  //   return this._connectionService
  //     .Request(verifyUserPermissionCommand)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       switch (error.error.errorCode) {
  //         case ErrorsEnum.USER_NOT_FOUND:
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.authentication.finalize_admin',
  //             'toast.authentication.error_code.verify_email'
  //           );
  //           break;
  //         case ErrorsEnum.INVALID_CURRENT_PASSWORD:
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.authentication.finalize_admin',
  //             'toast.authentication.error_code.password_invalid'
  //           );
  //           break;
  //         case ErrorsEnum.USER_NOT_AUTHORIZED:
  //           this._notificationsService.showInternalErrorMessage(
  //             'toast.authentication.finalize_admin',
  //             'toast.authentication.error_code.finalize_role_invalid'
  //           );
  //           break;
  //         default:
  //           this._notificationsService.showHttpErrorMessage(
  //             'toast.admin.admin_info',
  //             error
  //           );
  //           break;
  //       }
  //       return Observable.throw(false);
  //     });
  // }

  // public acceptTerms(carrierId: number, termsId: number): Observable<any> {
  //   let command = new PutTermsAndConditionsStatusCommand(carrierId);
  //   command.setParameters(termsId);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response: any) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.status === 500) {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.terms_and_conditions',
  //           error
  //         );
  //       } else if (error.status !== 400) {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.terms_and_conditions',
  //           error
  //         );
  //       }
  //       return Observable.throw(error.error);
  //     });
  // }

  // public hasAgreedTerms(carrierId): Observable<boolean> {
  //   let statusCommand = new GetTermsAndConditionsStatusCommand(carrierId);
  //   return this._connectionService
  //     .Request(statusCommand)
  //     .map((data) => {
  //       return data;
  //     })
  //     .catch((error) => {
  //       if (error.status === 500) {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.terms_and_conditions',
  //           error
  //         );
  //       } else if (error.status !== 400) {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.terms_and_conditions',
  //           error
  //         );
  //       }
  //       return Observable.throw(error.error);
  //     });
  // }

  // public getTermsAndConditionsAgreement(carrierId): Observable<any> {
  //   let command = new GetTermsAndConditionsAgreementCommand(carrierId);
  //   return this._connectionService
  //     .Request(command)
  //     .map((response: TermsAndConditionDTO) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       if (error.status === 500) {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.terms_and_conditions',
  //           error
  //         );
  //       } else if (error.status !== 400) {
  //         this._notificationsService.showHttpErrorMessage(
  //           'toast.authentication.terms_and_conditions',
  //           error
  //         );
  //       }
  //       return Observable.throw(error.error);
  //     });
  // }

  // updatePBX(
  //   carrierId: number,
  //   userId: number
  // ) {
  //   let command = new UpdatePBXCommand();
  //   command.setUrlParameters(
  //     carrierId,
  //     userId
  //   );
  //   return this._connectionService
  //     .Request(command)
  //     .map((response) => {
  //       return response;
  //     })
  //     .catch((error) => {
  //       this._notificationsService.showHttpErrorMessage(
  //         'toast.shared.error_code.0',
  //         error
  //       );
  //       return Observable.throw(false);
  //     });
  // }

  updatePBXWait(
    carrierId: number,
    userId: number,
    opType: number
  ) {
    let command = new UpdatePBXWaitCommand();
    command.setUrlParameters(
      carrierId,
      userId,
      opType
    );

    return this._connectionService
      .Request(command)
      .pipe(
        map(response => {
          return response as any;
        }),
        catchError((error) => {
          //     this._notificationsService.showHttpErrorMessage(
          //       'toast.shared.error_code.0',
          //       error
          //     );
          return throwError(() => false);
        })
      );
  }
}
